import { useEffect } from "react";
import axiosInstance from "../api/axiosInstance";

export default function DeliveryLiveTracker() {

  useEffect(() => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported");
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        try {
          await axiosInstance.post("/delivery/update-location/", {
            latitude: lat,
            longitude: lng,
          });
        } catch (err) {
          console.error("Location update failed", err);
        }
      },
      (error) => {
        console.error("Location error:", error);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 5000,
      }
    );

    // cleanup when component unmounts
    return () => navigator.geolocation.clearWatch(watchId);

  }, []);

  return (
    <div>
      <h3>Live location tracking enabled</h3>
    </div>
  );
}
